angular.module('cvsApp').service('getFavoriteStoresService',['networkService', 'xdrService', 'getFavoriteStoresModel', 'configManager','cvsAppData', function (NS, XS, GFSM, CM, CAD) {
   	
	function getFavoriteStoresService (){	
		this.getFavoriteStores = function(callBackSuccess){
            var tokenId, tokenType;
			//get url
            /**
             * SP 12/08/2016 - ITPR015400 - Guest Refill
             * Modified to read token and token type from app data
             */
			try {
                tokenId = CAD.getTokenId() ? CAD.getTokenId() : cvsUtility.queryMap.tokenId;
                tokenType = CAD.getTokenType() ? CAD.getTokenType() : 'Login';
            }
            catch(ex){
                tokenId = cvsUtility.queryMap.tokenID || cvsUtility.queryMap.tokenId;
                tokenType = 'Login';
			}
			var url = CM.getAPIUrlWithOtherInfo('GET_FAVORITE_STORES', tokenId,tokenType);
			var plainUrl = CM.getPlainApiUrl(url);
			var request = {url:plainUrl,
							header:{"Content-Type":"application/json","accept": "application/xml"},
							data:getRequestBody(url),
							onSuccess:callBackSuccess
						};
			cvsUtility.commonServiceCode(plainUrl,"getFavoriteStores",GFSM,request,callBackSuccess,NS);
							
		};
		

		var getRequestBody = function(entities){
			var requestJson = { serviceParams: CM.getModifiedParams(entities) };
			return requestJson;
		};			
	}
	
	return new getFavoriteStoresService();	
}]);
